import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "ReactionsInMessageList" */ './lazyIndex'),
    { name: 'ReactionsInMessageList' }
);

export const lazyFetchReactionDataForMessageList: LazyAction<
    typeof lazyIndex.fetchReactionDataForMessageList,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.fetchReactionDataForMessageList);

export const lazyRefreshMessageReactions: LazyImport<
    typeof lazyIndex.refreshMessageReactions,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.refreshMessageReactions);
